import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCountries, fetchDistricts, fetchDivisions, fetchTownships } from "./locationApi";

export const fetchCountriesThunk = createAsyncThunk(
    "location/fetchCountriesThunk",
    async (_, { rejectWithValue }) => {
        try {
            return await fetchCountries();
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchDivisionsThunk = createAsyncThunk(
    "location/fetchDivisionsThunk",
    async (countryCode, { rejectWithValue }) => {
        try {
            return await fetchDivisions(countryCode);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchDistrictsThunk = createAsyncThunk(
    "location/fetchDistrictsThunk",
    async ({ countryCode, divisionCode }, { rejectWithValue }) => {
        try {
            return await fetchDistricts({ countryCode, divisionCode });
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchTownshipsThunk = createAsyncThunk(
    "location/fetchTownshipsThunk",
    async ({ countryCode, divisionCode }, { rejectWithValue }) => {
        try {
            return await fetchTownships({ countryCode, divisionCode });
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
